import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

function Row({ label, value, testid }) {
  return (
    <div>
      <dt className="text-xs text-slate-500">{label}</dt>
      <dd className="text-sm font-medium text-slate-800" data-testid={testid}>{value || "—"}</dd>
    </div>
  );
}

export default function OverviewTab({ child }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6" data-testid="child-overview-tab">
      <Card>
        <CardHeader><CardTitle className="text-lg">Personal details</CardTitle></CardHeader>
        <CardContent>
          <dl className="grid grid-cols-2 gap-3">
            <Row label="Case ID" value={child.case_id} testid="overview-case-id" />
            <Row label="Age" value={child.age != null ? String(child.age) : null} />
            <Row label="First name" value={child.first_name} />
            <Row label="Surname" value={child.surname} />
            <Row label="Middle name" value={child.middle_name} />
            <Row label="Preferred name" value={child.preferred_name} />
            <Row label="Date of birth" value={child.date_of_birth} />
            <Row label="Gender" value={child.gender} />
            <Row label="Primary language" value={child.primary_language} />
            <Row label="Communication method" value={child.communication_method} />
          </dl>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="text-lg">Home information</CardTitle></CardHeader>
        <CardContent>
          <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2 mb-3">
            Sensitive — do not share or display outside operational need.
          </p>
          <dl className="grid grid-cols-2 gap-3">
            <Row label="Address line 1" value={child.address_line1} testid="overview-address1" />
            <Row label="Address line 2" value={child.address_line2} />
            <Row label="Town / City" value={child.address_town} />
            <Row label="Postcode" value={child.address_postcode} testid="overview-postcode" />
          </dl>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="text-lg">School</CardTitle></CardHeader>
        <CardContent>
          {child.school ? (
            <dl className="grid grid-cols-2 gap-3">
              <Row label="School" value={child.school.name} />
              <Row label="Address" value={[child.school.address, child.school.postcode].filter(Boolean).join(", ")} />
              <Row label="School contact" value={child.school.primary_contact} />
              <Row label="SENCO" value={child.school.senco_contact_name} />
              <Row label="Telephone" value={child.school.main_telephone} />
              <Row label="Email" value={child.school.main_email} />
            </dl>
          ) : (
            <p className="text-sm text-slate-600">No school linked yet.</p>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="text-lg">Local authority</CardTitle></CardHeader>
        <CardContent>
          <dl className="grid grid-cols-2 gap-3">
            <Row label="Commissioning authority" value={child.council?.name} />
            <Row label="Authority ref" value={child.council?.council_number} />
            <Row label="Council case reference" value={child.council_reference} testid="overview-council-ref" />
            <Row label="Photo consent status" value={child.photo_consent_status} testid="overview-photo-consent" />
          </dl>
        </CardContent>
      </Card>
    </div>
  );
}
